import moment from 'moment-timezone';

const INPUT_TIMEZONE = 'Europe/London';

class SessionBroadcast {
    constructor(broadcastRaw, userTimezone) {
        this.name = broadcastRaw.name;
        this.startMoment = moment.tz(`${broadcastRaw.broadcastStart}`, INPUT_TIMEZONE);
        this._userTimezone = userTimezone || moment.tz.guess();
        this.source = broadcastRaw.sourceUrl;
        this.shopIds = broadcastRaw.shopItems.map(item => item.id);

        const endMoment = moment.tz(`${broadcastRaw.broadcastStart}`, INPUT_TIMEZONE);
        this.endMoment = endMoment
            .add(7, 'd')
            .subtract(1, 's');
    }

    hasFinished() {
        const now = new Date();
        return now.valueOf() > this.endMoment.valueOf();
    }

    get broadcastStartDate() {
        return this.startMoment.tz(this._userTimezone).format("DD.MM.YYYY");
    }

    get broadcastStartTime() {
        return this.startMoment.tz(this._userTimezone).format("HH:mm");
    }

    get broadcastStartTimeShort() {
        return this.startMoment.tz(this._userTimezone).format("ha");
    }

    get broadcastEndDate() {
        return this.endMoment.tz(this._userTimezone).format("DD.MM.YYYY HH:mm:ss");
    }
}

export default SessionBroadcast;



// WEBPACK FOOTER //
// ./src/models/SessionBroadcast.js